import type { TEcall } from "types/elevationReferences.type"

export type RowDraft = {
	key: string
	elevationId: number | null
	elevationVersion: number
	elevationNumber: string
	savedElevationNumber: string
	referenceLabel: string
	savedReferenceLabel: string
	erefId: number | null
	errored: boolean
}

export const buildInitialRows = (ecall: TEcall): RowDraft[] =>
	ecall.elevation_numbers.map((en, index) => ({
		key: `el-${en.id ?? index}`,
		elevationId: en.id ?? null,
		elevationVersion: en.version ?? 0,
		elevationNumber: en.elevation_number ?? "",
		savedElevationNumber: en.elevation_number ?? "",
		referenceLabel: en.reference_label ?? "",
		savedReferenceLabel: en.reference_label ?? "",
		erefId: en.eref_id,
		errored: false,
	}))

// Fold a fresh server row list into the local drafts: saved rows take the server's values, a row
// the user is mid-way through editing keeps its draft (only its saved baseline + version move), a
// row deleted elsewhere drops out, and unsaved new rows stay where they are.
export const mergeIncomingRows = (prev: RowDraft[], incoming: RowDraft[]): RowDraft[] => {
	const prevById = new Map(prev.filter((row) => row.elevationId !== null).map((row) => [row.elevationId, row]))
	const merged = incoming.map((next) => {
		const current = prevById.get(next.elevationId)
		if (!current) return next
		const isNumberDirty = current.elevationNumber !== current.savedElevationNumber
		const isLabelDirty = current.referenceLabel !== current.savedReferenceLabel
		return {
			...next,
			key: current.key,
			elevationNumber: isNumberDirty ? current.elevationNumber : next.elevationNumber,
			referenceLabel: isLabelDirty ? current.referenceLabel : next.referenceLabel,
			errored: current.errored,
		}
	})
	return [...merged, ...prev.filter((row) => row.elevationId === null)]
}
